"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _helpers = require("../../lib/helpers");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _TrainLogin = _interopRequireDefault(require("./TrainLogin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TrainTooltip = function TrainTooltip(props) {
  var train = props.train,
    enableTagging = props.enableTagging;
  var properties = train.properties;
  var isGhost = properties.vehicle_status.toLowerCase() === 'ghost';
  var isUntagged = properties.vehicle_status.toLowerCase() === 'untagged';
  var lastUpdatedText = (0, _helpers.newGetLastUpdatedText)(properties.timestamp, properties.source);
  var generateTooltipHeader = function generateTooltipHeader(status) {
    switch (status) {
      case 'REVENUE':
        return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Header, {
          className: "tooltip-header revenue text-center"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-light"
        }, "Keolis Train", properties.operator, ' ', properties.trip_mode, ' ', properties.trip_short_name), /*#__PURE__*/_react["default"].createElement("h5", null, properties.headsign));
      case 'UNTAGGED':
        return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Header, {
          className: "text-center mb-1 p-1",
          style: {
            backgroundColor: '#585858'
          }
        }, /*#__PURE__*/_react["default"].createElement("h5", {
          className: "mb-0"
        }, properties.operator, ' ', "Vehicle ", ' ', properties.vehicle));
      default:
        return null;
    }
  };
  // console.log('train status on these ghost ones? ', properties)
  var generateTooltipContent = function generateTooltipContent(status) {
    switch (status) {
      case 'GHOST':
        {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              fontWeight: 'bold',
              fontSize: '1.25rem'
            }
          }, "Ghost trip ".concat(properties.trip_short_name)), (properties === null || properties === void 0 ? void 0 : properties.ghost_scheduled_time) && /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-2",
            style: {
              fontStyle: 'italic'
            }
          }, properties.ghost_scheduled_time));
        }
      case 'REVENUE':
        {
          var transferArray = [];
          if (properties.transfers) {
            transferArray = JSON.parse(properties.transfers);
          }
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, 'Keolis Vehicle ', properties.vehicle), properties.location_detail && /*#__PURE__*/_react["default"].createElement("div", null, properties.location_detail), /*#__PURE__*/_react["default"].createElement("div", null, properties.speed, ' ', "MPH"), properties.delay_sec !== null && properties.delay_sec !== undefined && /*#__PURE__*/_react["default"].createElement("strong", {
            className: "".concat((0, _helpers.getDelayClass)(properties.delay_sec), " text-uppercase")
          }, (0, _helpers.newGetDelayText)(Math.round(properties.delay_sec / 60))), properties.transfers && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "tooltip-subheader"
          }, /*#__PURE__*/_react["default"].createElement("strong", null, "Upcoming Timed Connections")), !!transferArray.length && transferArray.map(function (t) {
            var isBus = t.trip_route_type == 3;
            var icon = isBus ? _freeSolidSvgIcons.faBus : _freeSolidSvgIcons.faTrain;
            return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
              xs: 1
            }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
              icon: icon,
              size: "s",
              className: "train-icon mr-2"
            }))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react["default"].createElement("div", null, "".concat(t.trip_short_name, " ").concat(t.trip_headsign, " at ").concat(t.stop))));
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, "Last updated: ".concat(lastUpdatedText.time, " via ").concat(lastUpdatedText.via)));
        }
      case 'NON-REVENUE':
        {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "tooltip-header non-revenue"
          }, /*#__PURE__*/_react["default"].createElement("h5", null, properties.trip_short_name)), /*#__PURE__*/_react["default"].createElement("div", null, "Keolis ", ' ', properties.operator, ' ', "Vehicle", ' ', properties.vehicle), properties.location_detail && /*#__PURE__*/_react["default"].createElement("div", null, properties.location_detail), /*#__PURE__*/_react["default"].createElement("div", null, properties.speed, ' ', "MPH"), /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, "Last updated: ".concat(lastUpdatedText.time, " via ").concat(lastUpdatedText.via)));
        }
      case 'UNTAGGED':
        {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, properties.location_detail && /*#__PURE__*/_react["default"].createElement("div", null, properties.location_detail), /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, properties.speed, ' ', "MPH"), /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, "Last updated: ".concat(lastUpdatedText.time, " via ").concat(lastUpdatedText.via)));
        }
      default:
        {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Unknown vehicle status encountered"));
        }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card, {
    className: "train-card ".concat(isUntagged ? 'untagged' : 'tagged')
  }, generateTooltipHeader(properties.vehicle_status), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Body, {
    className: "very-low-padding"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "d-flex align-content-center justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
    className: "text-center"
  }, generateTooltipContent(properties.vehicle_status), !isGhost && enableTagging && /*#__PURE__*/_react["default"].createElement(_TrainLogin["default"], {
    properties: properties
  })))));
};
var _default = TrainTooltip;
exports["default"] = _default;